import React, { useState } from 'react';
import { Box, Button, Heading, Layer, TextInput } from 'grommet';
import { Close } from 'grommet-icons';
import PropTypes from 'prop-types';
import { SchoolService } from '@enrich/shared-lib';

export const SchoolManualReportButton = ({ school }) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <Button
                fill="vertical"
                primary
                size="medium"
                label="Send Manual Report"
                onClick={() => setShowModal(true)}
            />
            {showModal && (
                <SchoolManualReportModal
                    school={school}
                    setShowModal={setShowModal}
                />
            )}
        </>
    );
};

const SchoolManualReportModal = ({ school, setShowModal }) => {
    const [email, setEmail] = useState('');
    const [buttonBusy, setButtonBusy] = useState();

    const createReport = async () => {
        try {
            setButtonBusy(true);
            await new SchoolService().sendReport(school.id, email);
            setShowModal(false);
        } catch (error) {
            setButtonBusy(false);
            console.log(error);
        }
    };

    return (
        <Layer
            onClickOutside={() => setShowModal(false)}
            onEsc={() => setShowModal(false)}
            position="center">
            <Box
                background="white"
                pad="medium"
                round="6px"
                border={{ color: 'enrich-green-light', size: '3px' }}
                alignSelf="center"
                gap="30px">
                <Box direction="row" gap="20px" justify="between">
                    <Heading level="3" margin={{ vertical: 'none' }}>
                        Send manual report for {school.attributes.name}
                    </Heading>
                    <Box align="end">
                        <Close
                            onClick={() => {
                                setShowModal(false);
                            }}
                            cursor="pointer"
                        />
                    </Box>
                </Box>
                <Box>
                    <Box
                        width="medium"
                        align="center"
                        round="6px"
                        background="white">
                        <TextInput
                            dropHeight="medium"
                            onChange={(event) => setEmail(event.target.value)}
                            placeholder="Email"
                            value={email}
                        />
                    </Box>
                </Box>
                <Box>
                    <Button
                        primary
                        busy={buttonBusy}
                        disabled={!email.length}
                        label="Send email report"
                        style={{ width: '220px', height: '50px' }}
                        alignSelf="center"
                        onClick={createReport}
                    />
                </Box>
            </Box>
        </Layer>
    );
};

SchoolManualReportButton.propTypes = {
    school: PropTypes.object,
};

SchoolManualReportModal.propTypes = {
    school: PropTypes.object,
    setShowModal: PropTypes.func,
};
